import {
    Component,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
} from "@angular/core";

import { CloseButtonComponent } from "@hermes/aphrodite-close-button";
import { BannerItem } from "@hermes/api-model-shell";
import { BannerService } from "@hermes/domains-shell-states-shell-state";

import { COOKIE_BANNER_CLASS } from "../../constants/cookie.constants";
import { CookieLinkComponent } from "../cookie-link/cookie-link.component";

@Component({
    selector: "h-cookie-banner",
    imports: [CloseButtonComponent, CookieLinkComponent],
    templateUrl: "./cookie-banner.component.html",
    styleUrls: ["./cookie-banner.component.scss", "../banner-common.scss"],
})
export class CookieBannerComponent implements OnInit {
    private bannerService = inject(BannerService);

    public readonly COOKIE_BANNER_CLASS = COOKIE_BANNER_CLASS;

    /**
     * Banner data
     */
    @Input()
    public cookieBanner!: BannerItem;

    @Output()
    public closeBanner: EventEmitter<void> = new EventEmitter<void>();

    /**
     * Link label inside cookie banner
     */
    public cookieLink = $localize`:@@hermes.header_footer.cookie_banner.uri.label:click here`;
    public cookieMessage =
        $localize`:@@hermes.header_footer.cookie_banner.text:By continuing to browse this site, you are agreeing to the use of cookies for statistical and advertising purposes, as well as to facilitate information sharing on social networks. To find out more and change your cookie settings, !link.`.replace(
            "!link.",
            "",
        );
    public privacyPolicyMessage =
        $localize`:@@hermes.header_footer.cookie_banner.privacy_policy:`.replace(
            "!link.",
            "",
        );

    public ngOnInit(): void {
        this.saveCookieTimestamp();
    }

    /**
     * Trigger relevant closing method and emit output event
     */
    public close(): void {
        this.saveCookieTimestamp();
        this.closeBanner.emit();
    }

    /**
     * Update timestamp in cookie
     */
    private saveCookieTimestamp(): void {
        this.bannerService.saveCookieBanner(this.cookieBanner.cookieTimestamp);
    }
}
